import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const PlusIcon = ({ width, height }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6667 6.66667H9.33333V1.33333C9.33333 0.6 8.73333 0 8 0C7.26667 0 6.66667 0.6 6.66667 1.33333V6.66667H1.33333C0.6 6.66667 0 7.26667 0 8C0 8.73333 0.6 9.33333 1.33333 9.33333H6.66667V14.6667C6.66667 15.4 7.26667 16 8 16C8.73333 16 9.33333 15.4 9.33333 14.6667V9.33333H14.6667C15.4 9.33333 16 8.73333 16 8C16 7.26667 15.4 6.66667 14.6667 6.66667Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default PlusIcon;
